"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpsRequisitionResponseDtoRequisitionToJSON = exports.OpsRequisitionResponseDtoRequisitionFromJSONTyped = exports.OpsRequisitionResponseDtoRequisitionFromJSON = exports.instanceOfOpsRequisitionResponseDtoRequisition = exports.OpsRequisitionResponseDtoRequisitionStatusEnum = void 0;
var runtime_1 = require("../runtime");
var OpsAttachmentDto_1 = require("./OpsAttachmentDto");
var OpsMedicalNecessityRuleWithPolicyDto_1 = require("./OpsMedicalNecessityRuleWithPolicyDto");
var OpsMissingCriticalInfo_1 = require("./OpsMissingCriticalInfo");
var OpsPolicyDto_1 = require("./OpsPolicyDto");
var OpsProbandDto_1 = require("./OpsProbandDto");
var OpsRequisitionDtoMedicalNecessityRule_1 = require("./OpsRequisitionDtoMedicalNecessityRule");
var OpsRequisitionDtoPreferredPolicy_1 = require("./OpsRequisitionDtoPreferredPolicy");
/**
 * @export
 */
exports.OpsRequisitionResponseDtoRequisitionStatusEnum = {
    MedicalNecessityNotYetKnown: 'medical_necessity_not_yet_known',
    NoApplicablePolicies: 'no_applicable_policies',
    MedicalNecessityNotMet: 'medical_necessity_not_met',
    MedicalNecessityMet: 'medical_necessity_met',
    MissingCriticalInfo: 'missing_critical_info'
};
/**
 * Check if a given object implements the OpsRequisitionResponseDtoRequisition interface.
 */
function instanceOfOpsRequisitionResponseDtoRequisition(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "rqid" in value;
    isInstance = isInstance && "proband" in value;
    return isInstance;
}
exports.instanceOfOpsRequisitionResponseDtoRequisition = instanceOfOpsRequisitionResponseDtoRequisition;
function OpsRequisitionResponseDtoRequisitionFromJSON(json) {
    return OpsRequisitionResponseDtoRequisitionFromJSONTyped(json, false);
}
exports.OpsRequisitionResponseDtoRequisitionFromJSON = OpsRequisitionResponseDtoRequisitionFromJSON;
function OpsRequisitionResponseDtoRequisitionFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': json['id'],
        'rqid': json['rqid'],
        'userEmail': !(0, runtime_1.exists)(json, 'userEmail') ? undefined : json['userEmail'],
        'xifinPayorId': !(0, runtime_1.exists)(json, 'xifinPayorId') ? undefined : json['xifinPayorId'],
        'payorGroup': !(0, runtime_1.exists)(json, 'payorGroup') ? undefined : json['payorGroup'],
        'secondaryXifinPayorId': !(0, runtime_1.exists)(json, 'secondaryXifinPayorId') ? undefined : json['secondaryXifinPayorId'],
        'secondaryPayorGroup': !(0, runtime_1.exists)(json, 'secondaryPayorGroup') ? undefined : json['secondaryPayorGroup'],
        'prCodes': !(0, runtime_1.exists)(json, 'prCodes') ? undefined : json['prCodes'],
        'requisitionDate': !(0, runtime_1.exists)(json, 'requisitionDate') ? undefined : json['requisitionDate'],
        'sampleCollectionDate': !(0, runtime_1.exists)(json, 'sampleCollectionDate') ? undefined : json['sampleCollectionDate'],
        'paymentMethod': !(0, runtime_1.exists)(json, 'paymentMethod') ? undefined : json['paymentMethod'],
        'requisitionType': !(0, runtime_1.exists)(json, 'requisitionType') ? undefined : json['requisitionType'],
        'disallowDiscovery': !(0, runtime_1.exists)(json, 'disallowDiscovery') ? undefined : json['disallowDiscovery'],
        'positiveProbandHistory': !(0, runtime_1.exists)(json, 'positiveProbandHistory') ? undefined : json['positiveProbandHistory'],
        'positiveFamilyHistory': !(0, runtime_1.exists)(json, 'positiveFamilyHistory') ? undefined : json['positiveFamilyHistory'],
        'reqrepoPrimaryIndication': !(0, runtime_1.exists)(json, 'reqrepoPrimaryIndication') ? undefined : json['reqrepoPrimaryIndication'],
        'rawIndication': !(0, runtime_1.exists)(json, 'rawIndication') ? undefined : json['rawIndication'],
        'rawFamilyHistory': !(0, runtime_1.exists)(json, 'rawFamilyHistory') ? undefined : json['rawFamilyHistory'],
        'structuredMedicalDataSummary': !(0, runtime_1.exists)(json, 'structuredMedicalDataSummary') ? undefined : json['structuredMedicalDataSummary'],
        'proband': (0, OpsProbandDto_1.OpsProbandDtoFromJSON)(json['proband']),
        'testNames': !(0, runtime_1.exists)(json, 'testNames') ? undefined : json['testNames'],
        'attachments': !(0, runtime_1.exists)(json, 'attachments') ? undefined : (json['attachments'].map(OpsAttachmentDto_1.OpsAttachmentDtoFromJSON)),
        'preferredPolicy': !(0, runtime_1.exists)(json, 'preferredPolicy') ? undefined : (0, OpsRequisitionDtoPreferredPolicy_1.OpsRequisitionDtoPreferredPolicyFromJSON)(json['preferredPolicy']),
        'applicablePolicies': !(0, runtime_1.exists)(json, 'applicablePolicies') ? undefined : (json['applicablePolicies'].map(OpsPolicyDto_1.OpsPolicyDtoFromJSON)),
        'userSelectedPolicy': !(0, runtime_1.exists)(json, 'userSelectedPolicy') ? undefined : json['userSelectedPolicy'],
        'userSelectedNoApplicablePolicies': !(0, runtime_1.exists)(json, 'userSelectedNoApplicablePolicies') ? undefined : json['userSelectedNoApplicablePolicies'],
        'userSelectedCpts': !(0, runtime_1.exists)(json, 'userSelectedCpts') ? undefined : json['userSelectedCpts'],
        'policiesExhausted': !(0, runtime_1.exists)(json, 'policiesExhausted') ? undefined : json['policiesExhausted'],
        'plannerSelectedCpts': !(0, runtime_1.exists)(json, 'plannerSelectedCpts') ? undefined : json['plannerSelectedCpts'],
        'medicalNecessityRule': !(0, runtime_1.exists)(json, 'medicalNecessityRule') ? undefined : (0, OpsRequisitionDtoMedicalNecessityRule_1.OpsRequisitionDtoMedicalNecessityRuleFromJSON)(json['medicalNecessityRule']),
        'allMedicalNecessityRules': !(0, runtime_1.exists)(json, 'allMedicalNecessityRules') ? undefined : (json['allMedicalNecessityRules'].map(OpsMedicalNecessityRuleWithPolicyDto_1.OpsMedicalNecessityRuleWithPolicyDtoFromJSON)),
        'lmnGeneratedForMetRule': !(0, runtime_1.exists)(json, 'lmnGeneratedForMetRule') ? undefined : json['lmnGeneratedForMetRule'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : json['status'],
        'missingCriticalInfo': !(0, runtime_1.exists)(json, 'missingCriticalInfo') ? undefined : (json['missingCriticalInfo'].map(OpsMissingCriticalInfo_1.OpsMissingCriticalInfoFromJSON)),
        'lastEditor': !(0, runtime_1.exists)(json, 'lastEditor') ? undefined : json['lastEditor'],
        'lastEditorTimestamp': !(0, runtime_1.exists)(json, 'lastEditorTimestamp') ? undefined : json['lastEditorTimestamp'],
        'currentMedications': !(0, runtime_1.exists)(json, 'currentMedications') ? undefined : json['currentMedications'],
        'medicationsUnderConsideration': !(0, runtime_1.exists)(json, 'medicationsUnderConsideration') ? undefined : json['medicationsUnderConsideration'],
    };
}
exports.OpsRequisitionResponseDtoRequisitionFromJSONTyped = OpsRequisitionResponseDtoRequisitionFromJSONTyped;
function OpsRequisitionResponseDtoRequisitionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'rqid': value.rqid,
        'userEmail': value.userEmail,
        'xifinPayorId': value.xifinPayorId,
        'payorGroup': value.payorGroup,
        'secondaryXifinPayorId': value.secondaryXifinPayorId,
        'secondaryPayorGroup': value.secondaryPayorGroup,
        'prCodes': value.prCodes,
        'requisitionDate': value.requisitionDate,
        'sampleCollectionDate': value.sampleCollectionDate,
        'paymentMethod': value.paymentMethod,
        'requisitionType': value.requisitionType,
        'disallowDiscovery': value.disallowDiscovery,
        'positiveProbandHistory': value.positiveProbandHistory,
        'positiveFamilyHistory': value.positiveFamilyHistory,
        'reqrepoPrimaryIndication': value.reqrepoPrimaryIndication,
        'rawIndication': value.rawIndication,
        'rawFamilyHistory': value.rawFamilyHistory,
        'structuredMedicalDataSummary': value.structuredMedicalDataSummary,
        'proband': (0, OpsProbandDto_1.OpsProbandDtoToJSON)(value.proband),
        'testNames': value.testNames,
        'attachments': value.attachments === undefined ? undefined : (value.attachments.map(OpsAttachmentDto_1.OpsAttachmentDtoToJSON)),
        'preferredPolicy': (0, OpsRequisitionDtoPreferredPolicy_1.OpsRequisitionDtoPreferredPolicyToJSON)(value.preferredPolicy),
        'applicablePolicies': value.applicablePolicies === undefined ? undefined : (value.applicablePolicies.map(OpsPolicyDto_1.OpsPolicyDtoToJSON)),
        'userSelectedPolicy': value.userSelectedPolicy,
        'userSelectedNoApplicablePolicies': value.userSelectedNoApplicablePolicies,
        'userSelectedCpts': value.userSelectedCpts,
        'policiesExhausted': value.policiesExhausted,
        'plannerSelectedCpts': value.plannerSelectedCpts,
        'medicalNecessityRule': (0, OpsRequisitionDtoMedicalNecessityRule_1.OpsRequisitionDtoMedicalNecessityRuleToJSON)(value.medicalNecessityRule),
        'allMedicalNecessityRules': value.allMedicalNecessityRules === undefined ? undefined : (value.allMedicalNecessityRules.map(OpsMedicalNecessityRuleWithPolicyDto_1.OpsMedicalNecessityRuleWithPolicyDtoToJSON)),
        'lmnGeneratedForMetRule': value.lmnGeneratedForMetRule,
        'status': value.status,
        'missingCriticalInfo': value.missingCriticalInfo === undefined ? undefined : (value.missingCriticalInfo.map(OpsMissingCriticalInfo_1.OpsMissingCriticalInfoToJSON)),
        'lastEditor': value.lastEditor,
        'lastEditorTimestamp': value.lastEditorTimestamp,
        'currentMedications': value.currentMedications,
        'medicationsUnderConsideration': value.medicationsUnderConsideration,
    };
}
exports.OpsRequisitionResponseDtoRequisitionToJSON = OpsRequisitionResponseDtoRequisitionToJSON;
